import { useState, useEffect } from "react";
import { toast } from "sonner";
import api, { errMsg } from "@/lib/api";
import { X, Link2, Copy } from "lucide-react";
import { Switch } from "@/components/ui/switch";

export function ShareDialog({ view, onClose, onSaved }) {
  const [share, setShare] = useState(view.share || { enabled: false });
  const [days, setDays] = useState(30);
  useEffect(() => setShare(view.share || { enabled: false }), [view]);

  const toggle = async (enabled) => {
    try {
      const { data } = await api.post(`/views/${view.id}/share`, { enabled, expires_days: days });
      setShare(data);
      onSaved({ ...view, share: data });
      toast.success(enabled ? "Share link created" : "Share link disabled");
    } catch (e) {
      toast.error(errMsg(e));
    }
  };

  const url = share.token ? `${window.location.origin}/share/${share.token}` : null;
  return (
    <div className="fixed inset-0 z-50 bg-[#181B34]/40 backdrop-blur-sm flex items-center justify-center p-6" onClick={onClose}>
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-md p-6" onClick={(e) => e.stopPropagation()} data-testid="share-dialog">
        <div className="flex items-center gap-2 mb-4">
          <Link2 size={18} className="text-[#6161FF]" />
          <h3 className="text-lg font-black tracking-tight">Share "{view.name}"</h3>
        </div>
        <div className="flex items-center justify-between p-3 rounded-xl border border-[#181B34]/10 mb-4">
          <span className="text-sm font-bold">Public read-only link</span>
          <Switch data-testid="share-toggle" checked={!!share.enabled} onCheckedChange={toggle} />
        </div>
        {!share.enabled && (
          <div className="mb-4">
            <label className="text-xs font-bold uppercase tracking-[0.15em] text-[#676a82]">Expires after</label>
            <select value={days} onChange={(e) => setDays(Number(e.target.value))} className="mt-1.5 w-full h-10 px-2 rounded-lg border border-[#181B34]/15 font-semibold bg-white">
              {[7, 30, 90, 365].map((d) => <option key={d} value={d}>{d} days</option>)}
            </select>
          </div>
        )}
        {url && (
          <div className="flex gap-2">
            <input readOnly value={url} data-testid="share-url-input" className="flex-1 h-10 px-3 rounded-lg border border-[#181B34]/15 text-xs font-mono bg-[#F6F7FB]" />
            <button data-testid="copy-share-url" onClick={() => { navigator.clipboard.writeText(url); toast.success("Copied"); }}
              className="px-3 h-10 rounded-lg bg-[#6161FF] text-white"><Copy size={15} /></button>
          </div>
        )}
        <button onClick={onClose} className="mt-5 w-full h-10 rounded-xl bg-[#F0F3FF] font-bold text-[#4b4e63]">Done</button>
      </div>
    </div>
  );
}
